// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
//import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";
//import CenteredBlogCard from "examples/Cards/BlogCards/CenteredBlogCard";
import MKTypography from "components/MKTypography";
//import cource1 from "assets/images/cource1.jpg";
//import cource2 from "assets/images/2tankDive.jpg";
import CargoWreck from "assets/images/CargoWreck.jpg";
import BlackCoralWreck from "assets/images/BlackCoralWreck.jpg";
import MedufaruWreck from "assets/images/MedufaruWreck.jpg";
import ClarkeWreck from "assets/images/ClarkeWreck.jpg";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import { CardContent, Typography } from "@mui/material";
import CarWreck from "assets/images/CarWreck.JPG";
function Wrecksite() {
  return (
    <MKBox component="section" py={2}>
      <Container>
        <Grid item xs={12} lg={6}>
          <MKTypography variant="h3" mt={3} mb={0}>
            Wreck sites...
          </MKTypography>
          <MKTypography variant="body1" mt={4} mb={0}>
            Sri Lanka’s West Coast is famous for its historic wrecks, including the legendary HMS
            Hermes, cargo ships, and trawlers now transformed into thriving artificial reefs. With
            depths ranging from shallow sites to deeper technical dives, these wrecks attract
            abundant marine life and offer unforgettable adventures for divers of all levels.
          </MKTypography>
        </Grid>
      </Container>
      <Container>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} lg={6}>
            <MKTypography variant="h3" mt={-10} mb={0}>
              Cargo wreck
            </MKTypography>
            <MKTypography variant="body1" mt={1} mb={0}>
              The Cargo Wreck, lying off the West Coast near Colombo, is a fascinating dive site for
              wreck enthusiasts. Resting at a depth of around 30 meters, this sunken cargo vessel is
              covered in soft corals and sponges, attracting schools of snappers, groupers, and
              trevallies. Large swim-throughs and open holds make it an exciting site to explore,
              while the wreck’s structure has become home to moray eels, lionfish, and the
              occasional stingray. With generally good visibility during the November–April West
              Coast season, the Cargo Wreck is a favorite for intermediate to advanced divers.
            </MKTypography>
          </Grid>
          <Grid item xs={12} lg={6} sx={{ ml: "auto", mt: { xs: 8, lg: 8 } }}>
            <Card sx={{ maxWidth: 700, borderRadius: 1, boxShadow: 0 }}>
              <CardMedia
                component="img"
                image={CargoWreck}
                alt="Team Member"
                sx={{ height: 300, objectFit: "cover" }}
              />
              <CardContent>
                <Typography variant="body1" align="center" fontWeight="bold">
                  Cargo wreck
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
      <Container>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} lg={6}>
            <MKTypography variant="h3" mt={-10} mb={0}>
              Medufaru Wreck
            </MKTypography>
            <MKTypography variant="body1" mt={1} mb={0}>
              The Medufaru is a Maldivian cargo vessel that sank off the West Coast of Sri Lanka,
              and today it serves as one of the region’s most exciting wreck dives. Resting at a
              depth of around 32 meters, the wreck is largely intact, with the hull and
              superstructure now blanketed in soft corals, sponges, and colorful reef life. Divers
              exploring the Medufaru can expect to see large schools of snappers, trevallies,
              barracuda, and the occasional stingray or turtle cruising by. Its open holds and
              scattered debris fields create plenty of opportunities for safe penetration and
              exploration, making it a favorite among experienced divers.
            </MKTypography>
          </Grid>
          <Grid item xs={12} lg={6} sx={{ ml: "auto", mt: { xs: 8, lg: 3 } }}>
            <Card sx={{ maxWidth: 700, borderRadius: 1, boxShadow: 0 }}>
              <CardMedia
                component="img"
                image={MedufaruWreck}
                alt="Team Member"
                sx={{ height: 300, objectFit: "cover" }}
              />
              <CardContent>
                <Typography variant="body1" align="center" fontWeight="bold">
                  Medufaru Wreck
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
      <Container>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} lg={6}>
            <MKTypography variant="h3" mt={-10} mb={0}>
              Car Wreck
            </MKTypography>
            <MKTypography variant="body1" mt={1} mb={0}>
              The Car Wreck off Sri Lanka’s West Coast near Colombo is a unique and intriguing dive
              site where several vehicles went down with a cargo vessel. Today, the remains of cars
              lie scattered across the seabed at around 30 meters, creating an artificial reef that
              attracts a surprising amount of marine life. Over time, the wreck has become covered
              in corals, sponges, and algae, turning the once-metallic structures into a colorful
              underwater habitat. Schools of snapper and trevally swim between the vehicles, while
              lionfish, morays, and crustaceans hide in the shadows.
            </MKTypography>
          </Grid>
          <Grid item xs={12} lg={6} sx={{ ml: "auto", mt: { xs: 8, lg: 3 } }}>
            <Card sx={{ maxWidth: 700, borderRadius: 1, boxShadow: 0 }}>
              <CardMedia
                component="img"
                image={CarWreck}
                alt="Team Member"
                sx={{ height: 300, objectFit: "cover" }}
              />
              <CardContent>
                <Typography variant="body1" align="center" fontWeight="bold">
                  Car Wreck
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
      <Container>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} lg={6}>
            <MKTypography variant="h3" mt={-10} mb={0}>
              Clarke’s Wreck – A Historic Dive Site
            </MKTypography>
            <MKTypography variant="body1" mt={1} mb={0}>
              Clarke’s Wreck is one of Colombo’s most fascinating shipwrecks, offering a blend of
              history, mystery, and marine beauty. The wreck rests at a depth of around 22–28
              meters, making it suitable for experienced divers who enjoy exploring underwater
              heritage. Originally a merchant vessel, Clarke’s Wreck went down decades ago and has
              since transformed into a vibrant marine habitat. Its skeletal remains are now home to
              a variety of marine species including snappers, barracudas, groupers, lionfish, and
              moray eels. Over time, corals and sponges have colonized the structure, adding vibrant
              color to the rusting hull.
            </MKTypography>
          </Grid>
          <Grid item xs={12} lg={6} sx={{ ml: "auto", mt: { xs: 8, lg: 3 } }}>
            <Card sx={{ maxWidth: 700, borderRadius: 1, boxShadow: 0 }}>
              <CardMedia
                component="img"
                image={ClarkeWreck}
                alt="Team Member"
                sx={{ height: 300, objectFit: "cover" }}
              />
              <CardContent>
                <Typography variant="body1" align="center" fontWeight="bold">
                  Clarke’s Wreck
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
      <Container>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} lg={6}>
            <MKTypography variant="h3" mt={-10} mb={0}>
              Black Coral Wreck – A Diver’s Hidden Gem
            </MKTypography>
            <MKTypography variant="body1" mt={1} mb={0}>
              The Black Coral Wreck is one of the lesser-known but highly rewarding dive sites off
              the coast of Colombo, Sri Lanka. Resting at a depth of 30–32 meters, this sunken
              vessel has gradually transformed into a living reef, creating a fascinating playground
              for advanced divers. What makes this wreck special is the abundance of rare black
              corals that cling to its structure — a striking sight against the backdrop of rusted
              steel. The coral growth, combined with sponges and soft corals, has turned the wreck
              into a thriving oasis of marine biodiversity.
            </MKTypography>
          </Grid>
          <Grid item xs={12} lg={6} sx={{ ml: "auto", mt: { xs: 8, lg: 3 } }}>
            <Card sx={{ maxWidth: 700, borderRadius: 1, boxShadow: 0 }}>
              <CardMedia
                component="img"
                image={BlackCoralWreck}
                alt="Team Member"
                sx={{ height: 300, objectFit: "cover" }}
              />
              <CardContent>
                <Typography variant="body1" align="center" fontWeight="bold">
                  Black Coral Wreck
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Wrecksite;
